import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Popover, PopoverClose, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

interface ScopeDiagramPickerProps {
  label: string;
  diagrams: { name: string }[];
  defaultIndices: number[];
  onInsert: (indices: number[]) => void;
}

export default function ScopeDiagramPicker({
  label,
  diagrams,
  defaultIndices,
  onInsert,
}: ScopeDiagramPickerProps) {
  const [selectedIdx, setSelectedIdx] = useState<number[]>(defaultIndices);

  const toggle = (idx: number) =>
    setSelectedIdx((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm">{label}</Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64">
        <p className="text-sm font-medium mb-3">Select diagrams</p>
        <div className="space-y-2 mb-3">
          {diagrams.map((d, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm">
              <Checkbox
                checked={selectedIdx.includes(idx)}
                onCheckedChange={(checked) =>
                  setSelectedIdx((prev) =>
                    checked ? [...prev, idx] : prev.filter((i) => i !== idx)
                  )
                }
              />
              <span
                className="cursor-pointer select-none"
                onClick={() => toggle(idx)}
              >
                {d.name}
              </span>
            </div>
          ))}
        </div>
        <PopoverClose asChild>
          <Button
            size="sm"
            className="w-full"
            disabled={selectedIdx.length === 0}
            onClick={() => onInsert(selectedIdx)}
          >
            Insert
          </Button>
        </PopoverClose>
      </PopoverContent>
    </Popover>
  );
}
